<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col  :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['gift_user_app']">
              <a-select  :placeholder="language['column.pleaseChoose']+language['gift_user_app']" @change='$forceUpdate'  v-model='queryParam.app' :disabled='appLimit.flag' >
                <a-select-option v-for="(value, key) in appOptions" :key="key" :value="key">
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="供應商">
              <a-input placeholder="请输入供應商" v-model="queryParam.supplier"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="訂單編號">
              <a-input placeholder="请输入訂單編號" v-model="queryParam.orderno"></a-input>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
           <a-col :xl="6" :lg="7" :md="8" :sm="24">
                     <a-form-item label="員工工號">
                       <a-input placeholder="请输入員工工號" v-model="queryParam.empId"></a-input>
                     </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="商品名稱">
                <a-input placeholder="请输入商品名稱" v-model="queryParam.productName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="員工姓名">
                <a-input placeholder="请输入員工姓名" v-model="queryParam.empName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="所屬法人">
                <a-input placeholder="请输入所屬法人" v-model="queryParam.empCompany"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
              <a-form-item label="訂單成立時間">
                <j-date placeholder="请选择开始日期" class="query-group-cust" v-model="queryParam.createTime_begin"></j-date>
                <span class="query-group-split-cust"></span>
                <j-date placeholder="请选择结束日期" class="query-group-cust" v-model="queryParam.createTime_end"></j-date>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="收件人">
                <a-input placeholder="请输入收件人" v-model="queryParam.recipient"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="收件人手機號">
                <a-input placeholder="请输入收件人手機號" v-model="queryParam.empMobile"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="收件人郵箱地址">
                <a-input placeholder="请输入收件人郵箱地址" v-model="queryParam.empEmail"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="訂單狀態">
                <a-select placeholder="請選擇訂單狀態" v-model="queryParam.status" :options='statusOption' >
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="運單公司">
                <a-input placeholder="请输入運單公司" v-model="queryParam.logisticsCompany"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="運單單號">
                <a-input placeholder="请输入運單單號" v-model="queryParam.logisticsNo"></a-input>
              </a-form-item>
            </a-col> -->
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('訂單明細')">导出</a-button>
      <!-- 高级查询区域 -->
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="orderno"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="tmsEdit(record)">编辑运单号</a>
          <a-divider type="vertical" /> -->
          <a @click="handleDetail(record)">详情</a>
        </span>

      </a-table>
    </div>

    <view-order-user-detail-modal ref="modalForm" @ok="modalFormOk"></view-order-user-detail-modal>
    <OrderTmsForm ref="OrderTmsForm" @ok="modalFormOk"></OrderTmsForm>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ViewOrderUserDetailModal from './modules/ViewOrderUserDetailModal'
  import OrderTmsForm from './modules/OrderTmsModal'
  import { downFile, getAction, postAction } from '@api/manage'

  export default {
    name: 'ViewOrderUserDetailList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      ViewOrderUserDetailModal,
      OrderTmsForm
    },
    data () {
      return {
        statusOption: [
          {
            value: '0',
            label: '已下單',
          }, {
            value: '1',
            label: '結單處理中',
          },{
            value: '2',
            label: '已發貨',
          }
        ],
        disableMixinCreated: true,
        description: '訂單管理',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'訂單編號',
            align:"left",
            dataIndex: 'orderno'
          },
          {
            title:'供應商',
            align:"left",
            sorter: true,
            dataIndex: 'supplier'
          },
          {
            title:'商品編碼',
            align:"center",
            sorter: true,
            dataIndex: 'productId'
          },
          {
            title:'商品名稱',
            align:"left",
            sorter: true,
            dataIndex: 'productName'
          },
          {
            title:'商品數量',
            align:"right",
            dataIndex: 'prodnum'
          },
          {
            title:'商品單價',
            align:"right",
            dataIndex: 'price'
          },
          {
            title:'點數',
            align:"right",
            dataIndex: 'points'
          },
          {
            title:'配送日期',
            align:"left",
            dataIndex:'deliverTitle'
          },
          {
            title:'訂單狀態',
            align:"left",
            dataIndex:'statusName'
          },
          {
            title:'結單時間',
            align:"left",
            dataIndex:'confirmTime'
          },
          {
            title:'員工工號',
            align:"left",
            sorter: true,
            dataIndex: 'empId'
          },
          {
            title:'員工姓名',
            align:"left",
            sorter: true,
            dataIndex: 'empName'
          },
          {
            title:'所屬法人',
            align:"left",
            dataIndex: 'empCompany'
          },
          {
            title:'付费法人',
            align:"left",
            dataIndex:'payingLegalPerson'
          },
          {
            title:'收件人',
            align:"left",
            sorter: true,
            dataIndex: 'recipient'
          },
          {
            title:'收件人手機號',
            align:"left",
            sorter: true,
            dataIndex: 'empMobile'
          },
          {
            title:'收件人固話',
            align:"left",
            dataIndex: 'empPhone'
          },
          {
            title:'郵箱地址',
            align:"left",
            sorter: true,
            dataIndex: 'empEmail'
          },
          {
            title:'收件地址',
            align:"left",
            sorter: true,
            dataIndex: 'empAddress'
          },
          {
            title:'訂單備註',
            align:"left",
            dataIndex: 'noteMessage'
          },
          {
            title:'是否代收',
            align:"center",
            dataIndex: 'adminCollect_dictText'
          },
          {
            title:'活動編碼',
            align:"center",
            dataIndex: 'app'
          },
          {
            title:'活動名稱',
            align:"center",
            dataIndex: 'appName'
          },
          /* {
            title:'運單公司',
            align:"left",
            sorter: true,
            dataIndex: 'logisticsCompany'
          },
          {
            title:'運單單號',
            align:"left",
            sorter: true,
            dataIndex: 'logisticsNo'
          }, */
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/carnival/order/viewOrderDetails",
          exportXlsUrl: "/carnival/order/export-xls",
          getInitData: "/carnival/user/initData",
          checkAppLimit: '/carnival/app/checkAppLimit/code',
        },
        dictOptions:{},
        superFieldList:[],
        appOptions:[],
        appLimit:{
          flag: false,
          value: undefined
        }
      }
    },
    created() {
      this.checkAppLimit();
      this.getInitData();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      async checkAppLimit(){
        await getAction(this.url.checkAppLimit).then(res=>{
          if (res.success){
            this.appLimit.flag = true;
            this.appLimit.value = res.result;
            this.name = res.result;
            this.queryParam.app = this.appLimit.value;
          }
        })
        this.loadData(1);
      },
      searchReset(){
        this.queryParam = {} ;
        if(this.queryParam.flag){
          this.queryParam.app = this.appLimit.value;
        }
        this.loadData(1);
      },

      tmsEdit(record)
      {
         this.$refs.OrderTmsForm.edit(record);
      },
      getInitData(){
        getAction(this.url.getInitData).then(res=>{
          if (res.success){
            this.appOptions = res.result.app;
            this.$forceUpdate();
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
